///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Routes } from '@angular/router';
import { UserAuthorities } from '../services/user/user-authorities';
import { GtthPreferencesEditDialogPopupComponent } from './preferences-edit-dialog.component';
import { canActivateUser } from '../shared/auth/user-route-access-service';

export const preferencesPopups: Routes = [
    {
        path: 'preferences/edit',
        component: GtthPreferencesEditDialogPopupComponent,
        data: {
            authorities: [UserAuthorities.SIKLU_ADMIN, UserAuthorities.SIKLU_ACCOUNTANT],
            pageTitle: 'preferences.title'
        },
        canActivate: [canActivateUser],
        outlet: 'popup'
    }
];
